// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","modalZIndex":"3","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","body2":"_3SZbtBhXKsMgrIDYFmK8U","caption":"_1dJD2pSCq2-UhXWE_3mRfd","caption2":"_3FCgXshmQfWC83mTTDn6Lf","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","footerBlack":"#2f2f2f","customWhite":"#ffffff","footerGrey":"#c0c0c0","modal":"rEzTGI5h5uODi2mMPfCTW","modalMain":"_1vaw6Yt2Ln1YAidDn5u3Yo"};


//////////////////
// WEBPACK FOOTER
// ./src/common/modal/Modal.css
// module id = 293
// module chunks = 0 1 2